<template>
  <AppHookableComponent :resolve-hook-name="'$core.HeaderAppLogo.image'" class="logo">
    <img
      src="https://core-fw-files.imgix.net/u/core-fw-logo.svg"
      style="margin-left: 23px; height: 32px;"
    />
  </AppHookableComponent>
</template>
